import React from 'react';
import SiteFooter from '../components/footer/SiteFooter';
import SiteHeader from '../components/navigation/SiteHeader';
import SkipLink from '../components/ui/SkipLink';
import MarkdownArticle from '../components/writing/MarkdownArticle';
import styles from '../components/writing/Writing.module.css';

function BlogArticlePage({ post }) {
  const authors = Array.isArray(post.author) ? post.author.join(', ') : post.author;

  return (
    <>
      <SkipLink />
      <SiteHeader />
      <main className={styles.page} id="main-content">
        <article className={styles.article}>
          <a className={styles.backLink} href="/blog/">
            ← All writing
          </a>
          <div className={styles.articleHeader}>
            <p className={styles.sectionLabel}>{post.category || 'Field note'}</p>
            <h1>{post.title}</h1>
            <p className={styles.articleMeta}>
              {authors && <span>By {authors}</span>}
              {post.date && <time dateTime={post.date}>{post.date}</time>}
              {post.read_time && <span>{post.read_time}</span>}
            </p>
          </div>
          <MarkdownArticle
            articleSlug={post.slug}
            content={post.content}
            title={post.title}
          />
        </article>
      </main>
      <SiteFooter />
    </>
  );
}

export default BlogArticlePage;
